import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM17.4397 8.9083C17.6652 8.66547 17.6511 8.28583 17.4083 8.06035C17.1655 7.83487 16.7858 7.84893 16.5603 8.09176L10.484 14.6355L7.42429 11.5758C7.18997 11.3414 6.81007 11.3414 6.57576 11.5758C6.34145 11.8101 6.34145 12.19 6.57576 12.4243L10.0758 15.9243C10.191 16.0395 10.3482 16.1029 10.5111 16.0999C10.6741 16.0969 10.8288 16.0277 10.9397 15.9083L17.4397 8.9083Z",
		fill: "currentColor"
	})
});
export default SvgCheckCircleFill;
